import {
  AccessToken,
  GetTokenOptions,
  TokenCredential,
} from "@azure/core-auth";
import {
  IPublicClientApplication,
  AccountInfo,
  AuthenticationResult,
} from "@azure/msal-browser";

// Define the scope for Azure Maps
export const mapsSearchScope = "https://atlas.microsoft.com/.default";

export class MsalTokenCredential implements TokenCredential {
  private msalInstance: IPublicClientApplication;
  private account: AccountInfo;

  constructor(msalInstance: IPublicClientApplication, account: AccountInfo) {
    this.msalInstance = msalInstance;
    this.account = account;
  }

  public async getToken(
    scopes: string | string[],
    options?: GetTokenOptions
  ): Promise<AccessToken | null> {
    // MSAL uses an array of scopes, so ensure it's in the correct format
    const scope = Array.isArray(scopes) ? scopes.join(" ") : scopes;

    try {
      const response: AuthenticationResult =
        await this.msalInstance.acquireTokenSilent({
          scopes: [scope],
          account: this.account,
        });

      if (response.accessToken && response.expiresOn) {
        return {
          token: response.accessToken,
          expiresOnTimestamp: response.expiresOn.getTime(),
        };
      }

      return null;
    } catch (error) {
      console.error("Failed to acquire token silently from MSAL:", error);
      // You could optionally handle interactive token acquisition here if silent fails
      return null;
    }
  }
}
